var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0664 24.6641L15.0662 15.0676L24.6641 15.0664V13.0977L15.0662 13.0978L15.0664 3.5H13.0484L13.0474 13.0978L3.5 13.0977V15.0664L13.0474 15.0676L13.0484 24.6641H15.0664Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.c1bd37dc127cdde2a00330b281e7dcb8.svg";
export { ForwardRef as ReactComponent };